/*
(function ($) {
  $(document).ready(function ($) {
    // When the back in stock form is clicked
    $("#bis-subscribe button").click(function (event) {
      event.preventDefault();

      var $this = $(this),
        $form = $this.closest("form"),
        $msgElem = $("#bis-message"),
        message = "You've been added to the list, keep an eye on your inbox",
        selectedProduct = $("#bis-productid").text().trim(), // Get the JSON string from #bis-productid
        email = $form.find("#bis-email").val(),
        listID = $form.data("listid"), // Correct variable name
        backinstock = "Notify for Back in Stock", // Define the back in stock message
        source = "Back in Stock Form"; // Define the source of the subscription

      // Parse selectedProduct from JSON
      try {
        selectedProduct = JSON.parse(selectedProduct);
      } catch (error) {
        console.error("Invalid JSON in #bis-productid", error);
      }

      //console.log("Selected Product:", selectedProduct);

      BisKlaviyoSubscribe(
        listID,
        email,
        backinstock,
        selectedProduct, // Passing the entire JSON object
        source,
        $form,
        $msgElem,
        message
      );
    });

    function BisKlaviyoSubscribe(
      listID,
      email,
      backinstock,
      selectedProduct,
      source,
      $form,
      $msgElem,
      message
    ) {
      var subscribed = false;

      //console.log("selectedProduct before AJAX:", selectedProduct);
      //console.log("Type of selectedProduct:", typeof selectedProduct);

      $.ajax({
        type: "POST",
        url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
        data: {
          g: listID,
          $fields:
            "name, BackInStock, BackInStockProduct, $source, $consent, $email, Accepts Marketing",
          email: email,
          BackInStock: backinstock,
          BackInStockProduct: selectedProduct, // Ensure Klaviyo accepts this as JSON
          $consent: ["email"],
          AcceptsMarketing: true,
          $source: source,
        },
        contentType: "application/x-www-form-urlencoded",
        error: function (err) {
          console.log("Could not connect to Klaviyo.");
          console.log(err);
        },
        success: function (res) {
          console.log("inside success function");
          console.log(res);

          if (res.data.is_subscribed == false) {
            console.log(
              "User was not previously subscribed; data has been submitted."
            );
            subscribed = true;
          }

          if (res.data.is_subscribed == true) {
            console.log(
              "User is already subscribed, profile in Klaviyo should update."
            );

            // Identify the user in Klaviyo and add custom properties
            _learnq.push([
              "identify",
              {
                $email: email,
                BackInStockProduct: selectedProduct, // Passing the JSON object
                BackInStock: backinstock,
              },
            ]);

            // Track the event for analytics and segmentation
            _learnq.push([
              "track",
              "Subscribed to Back in Stock",
              {
                Product: selectedProduct, // Passing the JSON object
                BackInStockProduct: selectedProduct,
              },
            ]);
            subscribed = true;
          }

          // Remove the form and display the success message
          $form.remove();
          $msgElem.text(message);
        },
        async: false,
      });

      return subscribed;
    }
  });
})(jQuery);
*/
